import { Box, Typography } from '@material-ui/core'
import { useEffect } from 'react'

import Button from '@/components/button'
import Loading from '@/components/loading'
import { useGetRegionById } from '@/hooks/queries/use-get-region-by-id'
import { useProject } from '@/pages/projects-form/contexts/project-context'
import { GeoJSONObject } from '@/types/geospatial'

import { GeoJsonHandle } from './geojson-handle'
import { SelectFiles } from './select-files'
import { useStyles } from './styles'

export function SecondStep() {
  const classes = useStyles()

  const {
    form: { watch, setValue },
    context: {
      activeRegionName,
      goToBackRegion,
      goToNextRegion,
      isLoadingMutation,
      isEditProjectPage,
    },
  } = useProject()

  const regions = watch('regions')

  const currentRegionIndex = regions.findIndex(
    (region) => region.name === activeRegionName,
  )

  const currentRegion = regions[currentRegionIndex]

  const getRegionByIdQuery = useGetRegionById(currentRegion.id, {
    enabled: !currentRegion.synced,
  })

  function handlePrevious() {
    goToBackRegion(currentRegionIndex)
  }

  function handleNext() {
    goToNextRegion(currentRegionIndex)
  }

  function syncRegionWithForm() {
    setValue(`regions.${currentRegionIndex}`, {
      ...currentRegion!,
      geojson: getRegionByIdQuery.data?.geojson as GeoJSONObject,
      col_name: getRegionByIdQuery.data?.col_name || null,
      synced: true,
    })
  }

  useEffect(() => {
    if (getRegionByIdQuery.isSuccess && !currentRegion.synced) {
      syncRegionWithForm()
    }
  }, [
    getRegionByIdQuery.data,
    getRegionByIdQuery.isSuccess,
    currentRegion.synced,
  ])

  if (isEditProjectPage && currentRegion.id && !currentRegion.synced) {
    return <Loading />
  }

  return (
    <>
      <section className={classes.firstSection}>
        <Typography variant='h1'>
          Faça upload de arquivos .shp, .dbf, .cpg, .prj e .shx ou .kml
        </Typography>

        <Typography variant='h4'>Arquivos de processamento</Typography>

        {currentRegion.geojson ? (
          <GeoJsonHandle
            key={currentRegion.name}
            currentRegionIndex={currentRegionIndex}
          />
        ) : (
          <SelectFiles
            currentRegionIndex={currentRegionIndex}
            currentRegion={currentRegion}
          />
        )}
      </section>

      <section className={classes.buttonContainer}>
        <Button labelOnly onClick={handlePrevious}>
          Voltar
        </Button>
        <Box display='flex' gridGap='1.3rem'>
          <Button type='submit' outlined loading={isLoadingMutation}>
            Finalizar Cadastro
          </Button>
          <Button disabled={isLoadingMutation} onClick={handleNext}>
            Avançar
          </Button>
        </Box>
      </section>
    </>
  )
}
